import PidList from '../container/list/PidList';

function PidListPage() {
  return <PidList />;
}

export default PidListPage;
